import { render, staticRenderFns } from "./CollageResearches.vue?vue&type=template&id=f81731c0&"
import script from "./CollageResearches.vue?vue&type=script&lang=js&"
export * from "./CollageResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports